import { render } from "./WCMobileHeaderV2.vue?vue&type=template&id=2b00808a&scoped=true"
import script from "./WCMobileHeaderV2.vue?vue&type=script&lang=js"
export * from "./WCMobileHeaderV2.vue?vue&type=script&lang=js"

import "./WCMobileHeaderV2.vue?vue&type=style&index=0&id=2b00808a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b00808a"]])

export default __exports__